// Public payload for the `staff-user:{id}:tenant:{tenantId}:unreads:snapshot`
// channel (BL-2491, ADR 056 — Delivery Record § 9(c)).
//
// The one count a staff member's Inbox item renders at one house: unread
// @Inbox rows. Count only — never a body. The keys of
// `EMPTY_STAFF_UNREADS_SNAPSHOT` ARE the realtime-only set for rule #32: the
// count must not also reach the client through a REST envelope or an SSR prop
// on a surface that subscribes to this topic.
//
// Declared ONCE here so the catch-up route (admin-web) and the publisher
// (`@auctogon/realtime`) cannot drift on the shape the client folds.

/** The unread @Inbox count one staff member's shell subscribes to, at one house. */
export interface StaffUnreadsSnapshot {
    /** Unread @Inbox rows — the sidebar and phone-bar badge. */
    unreadCount: number;
}

/**
 * The pre-catch-up default, and what the catch-up route serves a person who has
 * no snapshot row yet at this house. Zero rather than `undefined` so the badge
 * resolves to "nothing unread" instead of never resolving.
 */
export const EMPTY_STAFF_UNREADS_SNAPSHOT: StaffUnreadsSnapshot = Object.freeze({
    unreadCount: 0,
});
